module.exports = "<h1>Welcome in your shop backoffice</h1>\n\n<p>Please login to proceed</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/LC/lc-app-dashboard/src/app/pages/home/home.component.html
// module id = ../../../../../src/app/pages/home/home.component.html
// module chunks = main